import { createActions } from 'reduxsauce'

export const { Types, Creators } = createActions({
  launchChat: [],
  setChatStartTime: ['chatStartTime'],
  toggleActive: ['windowIsActive'],
  toggleMinimized: ['windowIsMinimized'],
})
